import React from "react";
import { Space, Button, Typography, List, Steps } from "antd";
import Icon, {
  WindowsFilled,
  AppleFilled,
  createFromIconfontCN,
  ExclamationCircleTwoTone,
} from "@ant-design/icons";
import "./About.css";

const { Title, Text, Link } = Typography;

const linuxSvg = () => (
  <svg width="1em" height="1em" fill="currentColor" viewBox="0 0 1024 1024">
    <path
      d="M533.454557 0c-6.611245 0-13.435757 0.341226-20.43088 0.895717-180.295057 14.203514-132.480825 205.03391-135.21063 268.629825-3.284296 46.619943-12.795959 83.344344-44.828508 128.855303-37.748078 44.828508-90.723347 117.296287-115.846079 192.835096-11.857588 35.487459-17.48781 71.827981-12.241467 106.163803a18.084955 18.084955 0 0 0-4.734504 5.758182c-11.089831 11.431056-19.151285 25.63457-28.236416 35.786031-8.487986 8.487986-20.6868 11.388403-33.994596 17.061278-13.35045 5.800835-28.065803 11.47371-36.852361 29.046826-3.838788 8.018801-5.800835 16.762706-5.630222 25.63457 0 8.487986 1.151636 17.103931 2.345926 22.862113 2.473885 17.018625 4.947771 31.094179 1.663474 41.373599-10.577992 29.004173-11.900242 48.880562-4.478585 63.339995 7.421656 14.246167 22.81946 20.004349 40.05135 25.634571 34.591741 8.530639 81.467603 5.758181 118.362617 25.549264 39.496859 19.919042 79.590863 28.620294 111.58076 20.047002 22.435581-4.905117 41.3736-19.748429 51.52506-40.30727 25.037426-0.12796 52.46343-11.47371 96.396221-14.246167 29.814584-2.473885 67.13613 11.388403 109.959938 8.487986 1.06633 5.758181 2.687151 8.487986 4.862464 14.246167l0.12796 0.12796c16.677399 33.184186 47.473006 48.283417 80.35862 45.681572 32.885614-2.559192 67.903887-22.862113 96.268262-55.705073 26.914166-32.629694 71.785328-46.236064 101.429298-64.107753 14.843312-8.487986 26.82886-20.004349 27.681924-36.383176 0.981023-17.061278-8.487986-34.634395-30.454381-58.73345v-4.13736l-0.12796-0.127959c-7.251043-8.530639-10.663299-22.81946-14.41678-39.496859-3.625522-17.103931-7.762882-33.525412-20.985372-44.615242h-0.12796c-2.516539-2.303273-5.246343-2.857764-8.018801-5.758182a15.227191 15.227191 0 0 0-8.104107-2.729804c18.383527-54.510784 11.260444-108.765648-7.379002-157.560904-22.734153-60.141005-62.486931-112.519129-92.7707-148.561079-33.951944-42.866461-67.221436-83.472303-66.581638-143.698616 1.151636-91.789676 10.108807-261.592047-151.162925-261.847966z m22.563541 145.23413h0.554491c9.085131 0 16.890665 2.644498 24.909466 8.445333 8.14676 5.758181 14.075554 14.160861 18.724753 22.734153 4.478586 11.047178 6.739205 19.577817 7.08043 30.880913 0-0.853064 0.255919-1.706128 0.25592-2.516538v4.435932a3.668175 3.668175 0 0 1-0.170613-0.895717l-0.170613-1.023677a77.074324 77.074324 0 0 1-6.397979 30.113156 40.648495 40.648495 0 0 1-9.085131 14.288821 30.283769 30.283769 0 0 0-3.753481-1.791434c-4.478586-1.919394-8.487986-2.729805-12.156161-5.672875a55.960992 55.960992 0 0 0-9.34105-2.815111c2.090007-2.516539 6.184713-5.672875 7.762882-8.445333 2.260619-5.459609 3.497562-11.260444 3.753481-17.146584v-0.810411a51.610366 51.610366 0 0 0-2.601845-17.061278c-1.919394-5.758181-4.307973-8.573292-7.805534-14.246168-3.582868-2.815111-7.123084-5.630222-11.388404-5.630221h-0.682451c-3.966747 0-7.506962 1.279596-11.175137 5.630221a34.122556 34.122556 0 0 0-8.743905 14.246168 50.330771 50.330771 0 0 0-3.838788 17.061278v0.810411c0.085306 3.796134 0.341226 7.634922 0.853064 11.388403-8.232067-2.857764-18.6821-5.758181-25.890489-8.615946a69.737974 69.737974 0 0 1-0.767758-8.487986v-0.853064a75.581462 75.581462 0 0 1 6.39798-32.800307c3.497562-9.34105 9.895541-17.317197 18.340874-22.734153a42.013397 42.013397 0 0 1 25.335998-8.487986z m-126.338765 2.516539h1.535515c6.056754 0 11.516363 2.047353 17.018625 5.758181 6.227367 5.502262 11.260444 12.28412 14.672699 19.833736 3.838788 8.487986 6.014101 17.103931 6.525939 28.449681v0.170613c0.298572 5.715528 0.255919 8.573292-0.085306 11.34575v3.412256c-1.279596 0.298572-2.388579 0.767758-3.540216 1.023676-6.483286 2.345926-11.686976 5.758181-16.762705 8.530639 0.511838-3.796134 0.554492-7.634922 0.127959-11.388403v-0.639798c-0.511838-5.672875-1.663475-8.487986-3.497562-14.203514a26.146409 26.146409 0 0 0-7.08043-11.388403 10.577992 10.577992 0 0 0-7.805535-2.729804h-0.895717c-3.028377 0.255919-5.544915 1.748781-7.933494 5.630221a23.544564 23.544564 0 0 0-5.118384 11.516363 40.264616 40.264616 0 0 0-0.981023 14.118208v0.597145c0.511838 5.758181 1.578168 8.573292 3.454908 14.246167 1.919394 5.715528 4.13736 8.530639 7.037778 11.431056 0.469185 0.383879 0.895717 0.767758 1.450208 1.023677-2.985724 2.431232-4.990424 2.985724-7.506962 5.800834a13.009225 13.009225 0 0 1-5.587569 2.900418 111.794025 111.794025 0 0 1-11.729628-17.146585 75.581462 75.581462 0 0 1-6.611246-28.449681 75.026971 75.026971 0 0 1 3.412256-28.492335 60.994069 60.994069 0 0 1 12.070854-22.819459c5.459609-5.672875 11.089831-8.530639 17.829036-8.530639z m58.477531 72.766351c14.118208 0 31.222139 2.772458 51.823632 17.018625 12.497386 8.530639 22.307621 11.47371 44.913815 19.961695h0.127959c10.876565 5.800835 17.274544 11.34575 20.388228 17.018625v-5.587568a24.354975 24.354975 0 0 1 0.682451 20.047002c-5.246343 13.265144-22.009049 27.468658-45.383 35.956643v0.085307c-11.431056 5.758181-21.369251 14.203514-33.056226 19.833736-11.772282 5.758181-25.080079 12.454733-43.165034 11.388403a48.58199 48.58199 0 0 1-19.108632-2.857764 152.101295 152.101295 0 0 1-13.734328-8.445333c-8.317373-5.758181-15.48311-14.160861-26.103756-19.833736v-0.213266h-0.213266c-17.061278-10.492686-26.274368-21.838436-29.260092-30.326422-2.94307-11.431056-0.213266-20.004349 8.232067-25.591917 9.554316-5.758181 16.208214-11.559016 20.601493-14.331474 4.435932-3.156336 6.099407-4.350626 7.506962-5.587568h0.085307v-0.12796c7.20839-8.615945 18.596793-20.004349 35.786031-25.63457 5.928794-1.535515 12.540039-2.772458 19.876389-2.772458z m119.386294 91.405798c15.312497 60.439578 51.055875 148.219854 74.045947 190.787743 12.198814 22.776806 36.468482 70.761651 47.003821 128.983262 6.653898-0.213266 14.032901 0.767758 21.881089 2.729805 27.553964-71.273489-23.288645-147.878628-46.449329-169.162573-9.426356-8.573292-9.895541-14.28882-5.246343-14.28882 25.122732 22.776806 58.221612 67.050823 70.207159 117.594859 5.502262 22.81946 6.781858 47.089128 0.895717 71.230836 2.857764 1.194289 5.758181 2.601845 8.743905 2.857765 44.018098 22.776806 60.268965 40.008697 52.463431 65.557961v-1.834088c-2.601845-0.12796-5.118383 0-7.720229 0h-0.639798c6.440633-19.919042-7.762882-35.188886-45.425653-52.207511-39.027674-17.061278-70.20716-14.331474-75.538809 19.833736-0.298572 1.834087-0.511838 2.815111-0.725104 5.758182-2.900417 0.981023-5.928794 2.260619-8.914518 2.729804-18.340874 11.431056-28.236415 28.534988-33.823984 50.629343-5.544915 22.734153-7.251043 49.307094-8.743905 79.718822v0.12796c-0.895717 14.246167-7.293696 35.743378-13.606369 57.624467-63.979793 45.724225-152.698439 65.600614-228.151942 14.246167a112.817702 112.817702 0 0 0-17.146585-22.734153 61.847133 61.847133 0 0 0-11.729629-14.246168c7.762882 0 14.41678-1.236943 19.833736-2.857764a26.231715 26.231715 0 0 0 13.393104-14.246167c4.606545-11.388403 0-29.729277-14.715353-49.605666-14.715352-19.919042-39.710125-42.439929-76.263913-64.87551-26.871513-17.018625-42.056051-37.10828-49.051175-59.543861-7.037777-22.776806-6.099407-46.278717-0.639798-70.164506 10.450033-45.638919 37.23624-89.998242 54.340171-117.850779 4.563892-2.772458 1.578168 5.758181-17.402503 41.544212-16.890665 32.03255-48.667296 106.505029-5.20369 164.385415a346.514559 346.514559 0 0 1 27.596617-122.67059c24.056402-54.510784 74.34452-149.456797 78.311267-224.697033 2.047353 1.535515 9.255743 5.758181 12.326773 8.615946 9.298397 5.672875 16.208214 14.203514 25.165386 19.833735 8.999824 8.573292 20.345574 14.28882 37.364199 14.288821 1.663475 0.12796 3.19899 0.255919 4.734504 0.255919 17.530463 0 31.094179-5.715528 42.482583-11.431056 12.369427-5.715528 22.222315-14.246167 31.563364-17.061279h0.213266c19.919042-5.758181 35.658071-17.146585 44.57259-29.857236z m93.239885 382.087324c1.578168 25.63457 14.630046 53.103228 37.620118 58.73345 25.080079 5.715528 61.164682-14.203514 76.391873-32.629695l8.999824-0.383878c13.435757-0.341226 24.610894 0.426532 36.127257 11.388403l0.127959 0.127959c8.871865 8.487986 13.009225 22.648847 16.6774 37.364199 3.625522 17.103931 6.568592 33.269492 17.445156 45.468307 20.729453 22.478234 27.511311 38.643795 27.127433 48.624642l0.127959-0.255919v0.767758l-0.127959-0.511839c-0.639798 11.175137-7.890841 16.890665-21.241292 25.378652-26.871513 17.103931-74.472479 30.369075-104.798901 66.965516-26.359675 31.435405-58.477531 48.58199-86.841905 50.799956-28.321722 2.260619-52.762003-8.530639-67.13613-38.302569l-0.213266-0.12796c-8.957171-17.103931-5.118383-43.719525 2.388579-72.0839 7.506962-28.492335 18.255568-57.368548 19.74843-80.955765 1.578168-30.454381 3.241643-56.942016 8.317373-77.372896 5.118383-19.833736 13.137184-33.994597 27.340698-41.970745l1.919394-0.93837z m-461.294308 2.090006h0.426532c2.260619 0 4.478586 0.213266 6.696551 0.597145 16.037601 2.345926 30.113156 14.203514 43.634219 32.075203l38.814408 70.974917 0.12796 0.12796c10.364726 22.734153 32.160509 45.383 50.714649 69.865934 18.511487 25.506611 32.84296 48.240764 31.094179 66.965516v0.25592c-2.431232 31.733977-20.430881 48.965868-47.984844 55.193234-27.511311 5.758181-64.832857 0.085306-102.154403-19.791082-41.288293-22.862113-90.339468-20.004349-121.860179-25.677224-15.739029-2.815111-26.061102-8.573292-30.838261-17.103931-4.734505-8.487986-4.819811-25.63457 5.246343-52.46343v-0.12796l0.085307-0.12796c4.990424-14.246167 1.279596-32.117856-1.151637-47.728925-2.345926-17.103931-3.540215-30.241116 1.834088-40.094004 6.824511-14.246167 16.890665-17.018625 29.388051-22.734153 12.582693-5.758181 27.340698-8.615945 39.070327-20.004349h0.085307v-0.127959c10.919218-11.431056 18.980672-25.63457 28.492334-35.743378 8.104107-8.573292 16.208214-14.331474 28.279069-14.331474z m305.354225-387.035094c-18.55414 8.573292-40.30727 22.81946-63.467954 22.819459-23.118032 0-41.3736-11.388403-54.553437-19.876389-6.611245-5.715528-11.942895-11.431056-15.952295-14.28882-6.995124-5.715528-6.14206-14.246167-3.156337-14.246168 4.649198 0.682451 5.502262 5.758181 8.487986 8.573293 4.094707 2.815111 9.170437 8.487986 15.397804 14.203514 12.41208 8.530639 29.004173 19.919042 49.733626 19.919042 20.6868 0 44.913815-11.388403 59.629167-19.876389 8.317373-5.758181 18.980672-14.246167 27.63927-19.919042 6.653898-5.843488 6.355326-11.431056 11.900242-11.431057 5.502262 0.682451 1.450209 5.715528-6.27002 14.203514a345.405576 345.405576 0 0 1-29.430705 19.961696v-0.042653z m-46.150757-67.562662V240.564022c-0.255919-0.810411 0.554492-1.791434 1.236943-2.13266 3.156336-1.834087 7.677575-1.151636 11.089831 0.170613 2.687151 0 6.824511 2.857764 6.397979 5.758181-0.255919 2.090007-3.625522 2.815111-5.758182 2.815111-2.345926 0-3.924094-1.834087-6.0141-2.900417-2.217966-0.767758-6.227367-0.341226-6.952471-2.772458z m-23.501911 0c-0.853064 2.473885-4.819811 2.090007-7.08043 2.815111-2.0047 1.06633-3.668175 2.900417-5.928794 2.900417-2.175313 0-5.587569-0.810411-5.843488-2.900417-0.383879-2.815111 3.753481-5.672875 6.397979-5.672875 3.454909-1.322249 7.848188-2.0047 11.047178-0.213266 0.810411 0.383879 1.535515 1.279596 1.279596 2.13266v0.895717h0.127959z"
      fill=""
      p-id="2684"
    ></path>
  </svg>
);

const IconFont = createFromIconfontCN({
  scriptUrl: [
    "//at.alicdn.com/t/font_1788592_a5xf2bdic3u.js", // icon-python
  ],
});

const downloadsList = [
  {
    name: "Windows",
    icon: <WindowsFilled style={{ fontSize: "1.5rem" }} />,
    size: "28.0 Mb",
    available: true,
    url: "https://github.com/Aquets/VCAT-data-extractor/raw/main/extraction_tool.zip",
  },
  {
    name: "MacOS",
    icon: <AppleFilled style={{ fontSize: "1.5rem" }} />,
    size: "Coming soon",
    available: false,
    url: "",
  },
  {
    name: "Linux",
    icon: <Icon component={linuxSvg} style={{ fontSize: "1.5rem" }} />,
    size: "Coming soon",
    available: false,
    url: "",
  },
  {
    name: "Python",
    icon: <IconFont type="icon-python" style={{ fontSize: "1.5rem" }} />,
    size: "Source code",
    available: true,
    url: "https://github.com/Aquets/VCAT-data-extractor/tree/main/Source%20code",
  },
];

function Extraction() {
  return (
    <>
      <Space
        id="cover-extraction"
        className="center-content"
        align={"center"}
        direction={"horizontal"}
        size={100}
        style={{ padding: "100px 0", backgroundColor: "#FAFAFA" }}
      >
        <Space align={"left"} direction={"vertical"}>
          <Title level={1}>Extraction Tool</Title>
          <Text>
            The Extraction Tool is a command-line interface designed to extract
            data from Wikiprojects, articles, and images. It generates files
            that can be explored and accessed through the Dashboard.
          </Text>
        </Space>
        <List
          header={<b>Download Extraction Tool</b>}
          size="large"
          bordered
          dataSource={downloadsList}
          renderItem={(item) => (
            <List.Item>
              <div style={{ display: "flex", alignItems: "center" }}>
                {item.icon}
                <Text strong style={{ marginLeft: "1rem" }}>
                  {item.name}
                </Text>
              </div>
              <div>
                <Text type="secondary">{item.size}</Text>
                <Button
                  type="default"
                  disabled={!item.available}
                  style={{ marginLeft: "1rem" }}
                  href={item.url}
                  target={"_blank"}
                >
                  Download
                </Button>
              </div>
            </List.Item>
          )}
        ></List>
      </Space>

      <Space
        align={"center"}
        direction={"vertical"}
        size={20}
        id="text-extraction"
        className="center-content"
      >
        <div className="divider-medium"></div>

        <Title level={2}>How to use it</Title>
        <iframe
          width="560"
          height="315"
          src="https://www.youtube.com/embed/P6i60eEspB8"
          title="YouTube video player"
          frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          allowfullscreen
          style={{ borderRadius: "10px" }}
        ></iframe>
        <div className="divider-small"></div>
        <Steps
          direction="vertical"
          current={-1}
          items={[
            {
              title: <Title level={4}>Download the Extraction Tool</Title>,
              description: (
                <Text>
                  Select and download the correct version for you operating
                  system from the download area and extract the zipped files.
                </Text>
              ),
            },
            {
              title: <Title level={4}>Run extraction_tool.exe</Title>,
              description: (
                <Text>It opens a command-line interface with a menu.</Text>
              ),
            },
            {
              title: <Title level={4}>Extract the data</Title>,
              description: (
                <>
                  <Text>
                    You can either extract data from a Wikiproject or from a
                    custom list. Follow the instructions in the extraction tool.
                  </Text>
                  <Title level={5}>From Wikiproject</Title>
                  <Text>
                    Type the Wikiproject’s name (case sensitive). You can find
                    all the existing Wikiprojects at{" "}
                    <Link href="https://wp1.openzim.org/" target="_balnk">
                      https://wp1.openzim.org
                    </Link>
                    .
                  </Text>
                  <Title level={5}>From custom list</Title>
                  <Text>
                    Select the file containing the list from the input folder.
                    Lists must be .CSV files with one column named article. You
                    can check an{" "}
                    <Link
                      href="https://raw.githubusercontent.com/Aquets/VCAT-data-extractor/main/Source%20code/input/custom_list_example.csv"
                      target="_blank"
                    >
                      example here
                    </Link>
                    .
                  </Text>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      marginTop: "2rem",
                      gap: "1rem",
                    }}
                  >
                    <ExclamationCircleTwoTone
                      twoToneColor="#faad14"
                      style={{ fontSize: "1rem" }}
                    />
                    <Text>
                      With big Wikiprojects or long lists the extraction could
                      take more than 1 hour. Data are saved gradually, allowing
                      you to stop and resume the extraction.
                    </Text>
                  </div>
                </>
              ),
            },
            {
              title: <Title level={4}>Get the output file</Title>,
              description: (
                <Text>
                  You can find all the extracted data in the output folder,
                  named as the Wikiproject or the list’s file.
                </Text>
              ),
            },
            {
              title: <Title level={4}>Load the file</Title>,
              description: (
                <Text>
                  Upload the .JSON file in the{" "}
                  <Link href={`${window.location.pathname}#/dashboard`}>
                    dashboard
                  </Link>{" "}
                  and explore the dataset.
                </Text>
              ),
            },
          ]}
        />
      </Space>
      <div className="divider-big"></div>
    </>
  );
}

export default Extraction;
